import { NgModule } from '@angular/core';
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core';
import {
  orderTranslationChunksConfig,
  orderTranslationsDe,
  orderTranslationsEn,
  orderTranslationsZh,
} from '@spartacus/order/assets';
import { ORDER_FEATURE, OrderRootModule } from '@spartacus/order/root';

@NgModule({
  declarations: [],
  imports: [OrderRootModule],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [ORDER_FEATURE]: {
          module: () => import('./order-wrapper.module').then((m) => m.OrderWrapperModule),
        },
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: { en: orderTranslationsEn, de: orderTranslationsDe, zh: orderTranslationsZh },
        chunks: orderTranslationChunksConfig,
      },
    }),
  ],
})
export class OrderFeatureModule {}
